// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { debounce } from 'lodash'
import { func, object, oneOfType, string } from 'prop-types'

class DropDown extends React.Component {
  static displayName = 'DropDown'

  static propTypes = {
    Header: oneOfType([
      object.isRequired,
      string.isRequired,
    ]),
    idRoot: string.isRequired,
    Menu: oneOfType([
      func.isRequired,
      object.isRequired,
    ]),
  }

  state = {
    isOpen: false,
  }

  toggleOpen = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }))
  hideDebounce = debounce(this.toggleOpen, 600)

  // close the menu if a menu item was clicked.
  onClick = e => e.target.tagName === 'A' && this.toggleOpen()

  // close menu after 600 ms onMouseLeave
  mouseLeave = () => this.state.isOpen && this.hideDebounce()

  // cancel debounced close onMouseEnter
  mouseEnter = () => this.hideDebounce.cancel()

  render () {
    const {
      mouseEnter,
      mouseLeave,
      onClick,
      props: { Header, idRoot, Menu },
      state: { isOpen },
      toggleOpen,
    } = this

    const triggerClasses = `${isOpen ? 'active' : ''} dropdown-menu-trigger pointer heading-font uppercase`

    return (
      <div
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}>
        <p
          className={triggerClasses}
          id={`${idRoot}-trigger`}
          style={{ textDecoration: isOpen ? 'underline' : 'none' }}
          onClick={toggleOpen}>
          {Header}
        </p>
        <div
          className={`dropdown-menu ${isOpen ? 'active' : ''}`}
          id={`${idRoot}-menu`}
          onClick={onClick}>
          <Menu />
        </div>
      </div>
    )
  }
}

export default DropDown
